import React from "react";
import {
  ExpectedBillingCard,
  RevenuePercentageCard,
  MoMGrowthCard,
  JobsCountCard
} from "./stat-cells";

export function TypeStatsSection({ jobType, filters = {} }) {
  return (
    <div className="p-4 md:p-6">
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-4">
        <ExpectedBillingCard jobType={jobType} filters={filters} />
        <RevenuePercentageCard jobType={jobType} filters={filters} />
        <MoMGrowthCard jobType={jobType} filters={filters} />
        <JobsCountCard jobType={jobType} filters={filters} />
      </div>
    </div>
  );
}
